/* Do not change this file. */

import { mapState, mapGetters } from "vuex";

const AuthAPI = {
  computed: {
    ...mapState("env", ["publicKey"]),
    ...mapGetters(["getToken", "useAuth", "publicKey"]),
    url() {
      return (
        "https://courses.ecampus.oregonstate.edu/services/auth/public" +
        "/v2/session?public_key=" +
        this.publicKey
      );
    },
    config() {
      return {
        headers: { Authorization: `Bearer ${this.getToken}` }
      };
    }
  },
  methods: {
    validate() {
      if (!this.useAuth) {
        console.log("useauth");
        return false;
      }

      if (!this.publicKey) {
        console.warn("Attempting call without public_key.");
      }

      if (!this.getToken) {
        console.error("Attempting call without token.");
        return false;
      }

      return true;
    },
    readSession(cb) {
      if (!this.validate()) {
        return;
      }

      //console.log("Attempting Session Read...");

      let status = "";

      this.axios
        .get(this.url, this.config)
        .then((response) => {
          //console.log("Reading Session Response", response.data.session);
          status = response.data.session;
        })
        .catch((error) => {
          console.error("Session Error", error);
        })
        .finally(() => {
          //console.log("Completing Session Entry...");

          if (typeof cb === "function") {
            cb(status);
          }
        });
    }
  }
};

export default AuthAPI;
